import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

// import Custom Components
import PageHeader from "../../common/page-header";
import Breadcrumb from "../../common/breadcrumb";
import Accordion from "../../features/accordion/accordion";
import { getCartTotal } from "../../../services";
import validateToken from "../../../utils/TokenValidator";
import { createOrder, getAddress } from "../../../api";
import { toast } from "react-toastify";
import isvalidateAdddress from "../../../utils/CheckVaildAddress";
import CheckCartQty from "../../../handlers/CheckCartQty";
import Loader from "../../common/loader";
import { changeQty, removeFromCart, changeShipping } from "../../../actions";
import RemoveAllCartItems from "../../../utils/RemoveAllCartItems";


const paymentStyles = {
  input: {
    display: "none",
  },
  label: {
    cursor: "pointer",
    padding: "20px",
    border: "2px solid #ccc",
    backgroundColor: "#fff",
    width: "100%",
    marginBottom: -1,
  },
  labelHover: {
    backgroundColor: "#eee",
  },
  labelBefore: {
    content: '""',
    display: "inline-block",
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    backgroundColor: "#bbb",
    position: "relative",
    top: "5px",
    left: "5px",
    marginRight: "15px",
  },
  labelAfter: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    backgroundColor: "#fff",
    top: "5px",
    left: "5px",
  },
  labelBeforeChecked: {
    backgroundColor: "#654209",
    marginRight: "15px",
  },
  labelAfterChecked: {
    backgroundColor: "#654209",
    marginRight: "15px",
  },
  labelPaypal: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  labelImg: {
    alignItems: "end",
    marginLeft: "auto",
  },
  labelPaypalSpan: {
    marginLeft: "10px",
  },
};

function Checkout(props) {
  const navigate = useNavigate();
  const { cartlist, total, removeFromCart } = props;
  const shippingPrice = { free: 0, standard: 10, express: 20 };
  const shippingObj = {
    free: "Free shipping",
    standard: "Standard",
    express: "Express",
  };
  const [loading, setLoading] = useState(false);
  const [ShiptoDifferent, setShiptoDifferent] = useState(false);
  const [diffAddress, setdiffAddress] = useState({
    name: "",
    number: "",
    apt: "",
    street: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    phoneNumber: "",
  });
  const [Address, setAddress] = useState([]);
  const [OrderData, setOrderData] = useState({
    paymentDetails: "",
    paymentStatus: "pending",
    orderStatus: "confirmed",
    address: [Address ? Address[0] : ""],
    items: cartlist,
    orderNotes: "",
    ShippingType: props.shipping,
    paidUsing: "COD",
    TotalAmount: parseFloat(total + shippingPrice[props.shipping]),
  });

  const FetchAddress = async () => {
    try {
      const res = await getAddress();

      if (res) {
        setAddress([res[0]]);
        // Update OrderData with the fetched address
        setOrderData((prevOrderData) => ({
          ...prevOrderData,
          address: res[0] || "", // Set the address from the fetched result
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };
  const SettingPayment = (value) => {
    setOrderData((prevOrderData) => ({
      ...prevOrderData,
      paidUsing: value,
    }));
    console.log(Address);
  };

  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    handleScrollToTop();
    const { valid, expired } = validateToken();
    if (valid === false || expired === true) {
      window.location.href = "/login";
    }
    FetchAddress();
  }, []);

  const HandlePlaceOrder = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!OrderData.items.length) {
      setLoading(false);
      return toast.error("No Item Found");
    }
    if (!OrderData.address) {
      setLoading(false);
      return toast.error("Address Not Found");
    }
    if (OrderData.address) {
      const { valid, message } = isvalidateAdddress(OrderData.address);
      if (!valid) {
        setLoading(false);
        return toast.error(message);
      }
    }
    const { success, message } = await CheckCartQty(cartlist);

    if (!success) {
      setLoading(false);
      return toast.error(message);
    }
    if (OrderData.paidUsing === "COD") {
      // Api Call to Create Order
      await createOrder(OrderData)
        .then((res) => {
          setLoading(false);
          const searchParams = new URLSearchParams();
          searchParams.set("orderid", res.order.id);
          searchParams.set("totalamt", res.order.TotalAmount);

          const queryString = searchParams.toString();
          // localStorage.removeItem("liber-cartlist");
          RemoveAllCartItems(cartlist, removeFromCart);
          navigate(`/OrderSuccess?${queryString}`);
        })
        .catch((err) => {
          setLoading(false);
          toast.error("Failed to Place Order Try Again!");
        });
    } else if (OrderData.paidUsing === "PayPal") {
      // Create Order
      await createOrder(OrderData)
        .then((res) => {
          // API CAll to Payment``
          setLoading(false);
          RemoveAllCartItems(cartlist, removeFromCart);
          navigate(`/payments/paypal/process/${res.order.id}`);
        })
        .catch((err) => {
          setLoading(false);
          toast.error("Failed to Place Order Try Again!");
        });
    }
    setLoading(false);
  };

  const handleChangeDiffaddress = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setdiffAddress((prevAddress) => ({
      ...prevAddress,
      [name]: value,
    }));
  };

  const handlesetDiffAddresstoAddress = (e) => {
    e.preventDefault();
    setAddress([diffAddress]);
    setOrderData((prevOrderData) => ({
      ...prevOrderData,
      address: diffAddress,
    }));
    toast.success("Address  Saved");
  };

  return (
    <>
      {loading && <Loader />}
      <Helmet>
        <title>LIBER | Checkout</title>
      </Helmet>

      <h1 className="d-none">LIBER - Checkout</h1>

      <div className="main">
        <PageHeader title="Checkout" subTitle="Shop" />
        <Breadcrumb title="Checkout" parent1={["Shop", "shop/sidebar/list"]} />

        <div className="page-content">
          <div className="checkout">
            <div className="container">
              <div className="checkout-discount">
                {/* <form action="#">
                                    <input type="text" className="form-control" required id="checkout-discount-input" />
                                    <label htmlFor="checkout-discount-input" className="text-truncate">Have a coupon? <span>Click here to enter your code</span></label>
                                </form> */}
              </div>

              <div className="row">
                <div className="col-lg-9">
                  {Address ? (
                    <>
                      <div className="card card-dashboard">
                        <div className="card-body">
                          <h3 className="card-title">Address</h3>
                          {Address[0] ? (
                            Address.map((address) => (
                              <p>
                                {address.name ? (
                                  <>
                                    <strong> Name:</strong> {address.name}
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                                {address.number ? (
                                  <>
                                    <strong>Address: </strong>
                                    {address.number}
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                                {address.street ? (
                                  <>
                                    <strong>Street: </strong>
                                    {address.street}
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                                {address.city ? (
                                  <>
                                    <strong>City: </strong>
                                    {address.city}
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                                {address.state ? (
                                  <>
                                    <strong>State: </strong>
                                    {address.state}
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                                {address.country ? (
                                  <>
                                    <strong>Country: </strong>
                                    {address.country}
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                                {address.pincode ? (
                                  <>
                                    <strong>Zipcode </strong>
                                    {address.pincode}
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                                {address.phoneNumber ? (
                                  <>
                                    <strong>Ph No: </strong>
                                    {address.phoneNumber}
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                                <Link to="/shop/dashboard?tab=Addresses">
                                    Edit <i className="icon-edit"></i>
                                  </Link>
                              </p>
                            ))
                          ) : (
                            <p>
                              You have not set up this type of address yet.
                              <br />
                              <Link to="/shop/dashboard?tab=Addresses">
                                Edit <i className="icon-edit"></i>
                              </Link>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="checkout-diff-address"
                        />
                        <label
                          onClick={() => setShiptoDifferent(!ShiptoDifferent)}
                          className="custom-control-label"
                          htmlFor="checkout-diff-address"
                        >
                          Ship to a different address?
                        </label>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  {ShiptoDifferent ? (
                    <form onSubmit={handlesetDiffAddresstoAddress}>
                      <h2 className="checkout-title">Shipping Details</h2>
                      <div className="row">
                        <div className="col-sm-12">
                          <label>Full Name *</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={diffAddress.name}
                            onChange={(e) => handleChangeDiffaddress(e)}
                            required
                          />
                        </div>
                      </div>

                      <label>Street address *</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="House number and Street name"
                        name="number"
                        value={diffAddress.number}
                        onChange={(e) => handleChangeDiffaddress(e)}
                        required
                      />
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Appartments, suite, unit etc ..."
                        name="street"
                        value={diffAddress.street}
                        onChange={(e) => handleChangeDiffaddress(e)}
                        required
                      />

                      <div className="row">
                        <div className="col-sm-6">
                          <label>Town / City *</label>
                          <input
                            type="text"
                            className="form-control"
                            name="city"
                            value={diffAddress.city}
                            onChange={(e) => handleChangeDiffaddress(e)}
                            required
                          />
                        </div>

                        <div className="col-sm-6">
                          <label>State *</label>
                          <input
                            type="text"
                            className="form-control"
                            name="state"
                            value={diffAddress.state}
                            onChange={(e) => handleChangeDiffaddress(e)}
                            required
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-6">
                          <label>Postcode / ZIP *</label>
                          <input
                            type="text"
                            className="form-control"
                            name="pincode"
                            value={diffAddress.pincode}
                            onChange={(e) => handleChangeDiffaddress(e)}
                            required
                          />
                        </div>

                        <div className="col-sm-6">
                          <label>Country *</label>
                          <input
                            type="text"
                            className="form-control"
                            name="country"
                            value={diffAddress.country}
                            onChange={(e) => handleChangeDiffaddress(e)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <label>Phone *</label>
                        <input
                          type="tel"
                          className="form-control"
                          name="phoneNumber"
                          value={diffAddress.phoneNumber}
                          onChange={(e) => handleChangeDiffaddress(e)}
                          required
                        />
                      </div>
                      {/* <button
                        onClick={setDiffAddresstoAddress}
                        className="btn btn-outline-primary-2 btn-order btn-block"
                      >
                        Save
                      </button> */}
                      <input
                        type="submit"
                        value="Save"
                        className="btn btn-outline-primary-2 btn-order btn-block"
                      />
                    </form>
                  ) : (
                    ""
                  )}

                  <label>Order notes (optional)</label>
                  <textarea
                    className="form-control"
                    cols="30"
                    rows="4"
                    value={OrderData.orderNotes}
                    onChange={(e) =>
                      setOrderData((prevOrderData) => ({
                        ...prevOrderData,
                        orderNotes: e.target.value,
                      }))
                    }
                    placeholder="Notes about your order, e.g. special notes for delivery"
                  ></textarea>
                </div>

                <aside className="col-lg-3">
                  <form onSubmit={HandlePlaceOrder}>
                    <div className="summary">
                      <h3 className="summary-title">Your Order</h3>

                      <table className="table table-summary">
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th>Total</th>
                          </tr>
                        </thead>

                        <tbody>
                          {cartlist.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <Link to="#">{item.name}</Link>
                              </td>
                              <td>
                                $
                                {item.sum.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>
                            </tr>
                          ))}
                          <tr className="summary-subtotal">
                            <td>Subtotal:</td>
                            <td>
                              $
                              {total.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          </tr>
                          <tr>
                            <td>Shipping:</td>
                            <td>{shippingObj[props.shipping]}</td>
                          </tr>
                          <tr className="summary-total">
                            <td>Total:</td>
                            <td>
                              $
                              {(
                                total + shippingPrice[props.shipping]
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                          </tr>
                          <tr className="summary-subtotal">
                            <td>Payment Method:</td>
                            <td>{OrderData.paidUsing}</td>
                          </tr>
                        </tbody>
                      </table>

                      <Accordion type="checkout">
                        <div
                          style={
                            OrderData.paidUsing === "COD"
                              ? {
                                  border: "10px solid",
                                  borderImageSlice: 1,
                                  borderWidth: "5px",
                                  borderImageSource:
                                    "linear-gradient(to left, #c96, #c57729)",
                                  borderRadius: "10px",
                                }
                              : {}
                          }
                        >
                          <input
                            type="radio"
                            name="payment_method"
                            value="COD"
                            id="cod"
                            onClick={() => SettingPayment("COD")}
                            style={paymentStyles.input}
                          />
                          <label htmlFor="cod" style={paymentStyles.label}>
                            Cash on delivery
                          </label>
                        </div>
                        <div
                          style={
                            OrderData.paidUsing === "PayPal"
                              ? {
                                  border: "10px solid",
                                  borderImageSlice: 1,
                                  borderWidth: "5px",
                                  borderImageSource:
                                    "linear-gradient(to left, #c96, #c57729)",
                                  borderRadius: "10px",
                                }
                              : {}
                          }
                        >
                          <input
                            type="radio"
                            name="payment_method"
                            value="PayPal"
                            id="paypal"
                            onClick={() => SettingPayment("PayPal")}
                            style={paymentStyles.input}
                          />
                          <label htmlFor="paypal" style={paymentStyles.label}>
                            PayPal
                            <img
                              src="/assets/images/payments-summary.png"
                              alt="PayPal"
                              style={paymentStyles.labelImg}
                            />
                          </label>
                        </div>
                      </Accordion>

                      <button
                        type="submit"
                        className="btn btn-outline-primary-2 btn-order btn-block"
                      >
                        <span className="btn-text">Place Order</span>
                        <span className="btn-hover-text">
                          Proceed to Checkout
                        </span>
                      </button>
                    </div>
                  </form>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export const mapStateToProps = (state) => ({
  cartlist: state.cartlist.cart,
  total: getCartTotal(state.cartlist.cart),
  shipping: state.cartlist.shipping,
});

export default connect(mapStateToProps, {
  changeQty,
  removeFromCart,
  changeShipping,
})(Checkout);
// export default connect(mapStateToProps)(Checkout);
